<template>
	<div>
		<vs-row vs-w="12">
			<vs-col vs-w="5" vs-sm="12" class="p-2">
				<basic-settings></basic-settings>
			</vs-col>
			<vs-col vs-w="7" vs-sm="12" class="p-2">
				<multipliers-table></multipliers-table>
			</vs-col>
		</vs-row>


	</div>
</template>
<script>

	import MultipliersTable from "./Settings/MultipliersTable";
	import BasicSettings from "./Settings/BasicSettings";
	export default {
		components: {
			MultipliersTable,
			BasicSettings,
		},

	}
</script>
